import { Routes } from '@angular/router';
import { CanActivateguard } from '../../service/auth-service.service';


export const UserRoutes: Routes = [
    { path: 'createuser', loadComponent: () => import('../UserMaster/create-user/create-user.component').then(m => m.CreateUserComponent), canActivate: [CanActivateguard] },
    { path: 'viewuser', loadComponent: () => import('../UserMaster/view-user/view-user.component').then(m => m.ViewUserComponent), canActivate: [CanActivateguard] },
    { path: 'accesspermission', loadComponent: () => import('../UserMaster/access/access.component').then(m => m.AccessComponent), canActivate: [CanActivateguard] },
    { path: 'help', loadComponent: () => import('../UserMaster/help/help.component').then(m => m.HelpComponent), canActivate: [CanActivateguard] },
    // { path: 'users', loadComponent: () => import('../UserMaster/users/users.component').then(m => m.UsersComponent), canActivate: [CanActivateguard] },
];
